import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalStyles } from '@styles/GlobalStyles';
import { AuthProvider, FeatureFlagsProvider } from '@state/index';
import { AppRouter } from '@router/index';
// Feature flags can be configured via environment variables
// No feature flags currently defined - add them here as needed:
// const featureFlags = {
//   newFeatureName: process.env.NEW_FEATURE_NAME === 'true',
// };
export function App() {
    return (_jsx(FeatureFlagsProvider, { children: _jsxs(AuthProvider, { children: [_jsx(GlobalStyles, {}), _jsx(AppRouter, {})] }) }));
}
